module.exports = __webpack_public_path__ + "img/icons BFr_40.bb32d961.png";